export default __webpack_public_path__ + "static/media/Middle_School_Graduation_3_2.fe836427.png";